@file:OptIn(InternalResourceApi::class)

package top.clientapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.clientapp.generated.resources/"

@delegate:ResourceContentHash(-205_230_988)
internal val Res.string.client_profile_delete_account: StringResource by lazy {
      StringResource("string:client_profile_delete_account", "client_profile_delete_account", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3417, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7785, 77),
      ))
    }

@delegate:ResourceContentHash(-64_288_930)
internal val Res.string.client_profile_delete_error: StringResource by lazy {
      StringResource("string:client_profile_delete_error", "client_profile_delete_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3475, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7863, 103),
      ))
    }

@delegate:ResourceContentHash(1_394_068_469)
internal val Res.string.client_profile_delete_reason_label: StringResource by lazy {
      StringResource("string:client_profile_delete_reason_label", "client_profile_delete_reason_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3543, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7967, 86),
      ))
    }

@delegate:ResourceContentHash(-247_170_603)
internal val Res.string.client_profile_delete_reason_placeholder: StringResource by lazy {
      StringResource("string:client_profile_delete_reason_placeholder", "client_profile_delete_reason_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3606, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8054, 136),
      ))
    }

@delegate:ResourceContentHash(-2_001_675_246)
internal val Res.string.client_profile_delete_success: StringResource by lazy {
      StringResource("string:client_profile_delete_success", "client_profile_delete_success", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3711, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8191, 89),
      ))
    }

@delegate:ResourceContentHash(59_862_579)
internal val Res.string.client_profile_delete_warning_message: StringResource by lazy {
      StringResource("string:client_profile_delete_warning_message", "client_profile_delete_warning_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3777, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8281, 229),
      ))
    }

@delegate:ResourceContentHash(-1_245_553_819)
internal val Res.string.client_profile_delete_warning_title: StringResource by lazy {
      StringResource("string:client_profile_delete_warning_title", "client_profile_delete_warning_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3935, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8511, 143),
      ))
    }

@delegate:ResourceContentHash(-1_788_580_698)
internal val Res.string.client_profile_edit: StringResource by lazy {
      StringResource("string:client_profile_edit", "client_profile_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4039, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8655, 75),
      ))
    }

@delegate:ResourceContentHash(274_576_303)
internal val Res.string.client_profile_general_info: StringResource by lazy {
      StringResource("string:client_profile_general_info", "client_profile_general_info", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4083, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8731, 87),
      ))
    }

@delegate:ResourceContentHash(-449_056_039)
internal val Res.string.client_profile_load_error: StringResource by lazy {
      StringResource("string:client_profile_load_error", "client_profile_load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4147, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8819, 109),
      ))
    }

@delegate:ResourceContentHash(1_831_442_825)
internal val Res.string.client_profile_logout: StringResource by lazy {
      StringResource("string:client_profile_logout", "client_profile_logout", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4213, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8929, 45),
      ))
    }

@delegate:ResourceContentHash(486_082_610)
internal val Res.string.client_profile_my_reviews: StringResource by lazy {
      StringResource("string:client_profile_my_reviews", "client_profile_my_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4255, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8975, 61),
      ))
    }

@delegate:ResourceContentHash(441_098_617)
internal val Res.string.client_profile_no_reviews: StringResource by lazy {
      StringResource("string:client_profile_no_reviews", "client_profile_no_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4305, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9037, 81),
      ))
    }

@delegate:ResourceContentHash(-935_643_257)
internal val Res.string.client_profile_reviews_load_error: StringResource by lazy {
      StringResource("string:client_profile_reviews_load_error", "client_profile_reviews_load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4359, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9119, 117),
      ))
    }

@delegate:ResourceContentHash(1_273_264_559)
internal val Res.string.client_profile_reviews_unknown_venue: StringResource by lazy {
      StringResource("string:client_profile_reviews_unknown_venue", "client_profile_reviews_unknown_venue", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4433, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9237, 60),
      ))
    }

@delegate:ResourceContentHash(-2_036_349_797)
internal val Res.string.client_profile_save: StringResource by lazy {
      StringResource("string:client_profile_save", "client_profile_save", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4608, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9480, 51),
      ))
    }

@delegate:ResourceContentHash(292_049_457)
internal val Res.string.client_profile_save_error: StringResource by lazy {
      StringResource("string:client_profile_save_error", "client_profile_save_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4486, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9298, 101),
      ))
    }

@delegate:ResourceContentHash(197_981_247)
internal val Res.string.client_profile_save_success: StringResource by lazy {
      StringResource("string:client_profile_save_success", "client_profile_save_success", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4552, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9400, 79),
      ))
    }

@delegate:ResourceContentHash(-364_281_230)
internal val Res.string.client_profile_sign_in: StringResource by lazy {
      StringResource("string:client_profile_sign_in", "client_profile_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4644, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9532, 46),
      ))
    }

@delegate:ResourceContentHash(1_439_709_388)
internal val Res.string.client_profile_success_title: StringResource by lazy {
      StringResource("string:client_profile_success_title", "client_profile_success_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4687, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9579, 52),
      ))
    }

@delegate:ResourceContentHash(667_965_285)
internal val Res.string.client_profile_unknown_user: StringResource by lazy {
      StringResource("string:client_profile_unknown_user", "client_profile_unknown_user", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4732, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9632, 67),
      ))
    }

@delegate:ResourceContentHash(-1_473_493_463)
internal val Res.string.client_profile_user_activity: StringResource by lazy {
      StringResource("string:client_profile_user_activity", "client_profile_user_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4780, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9700, 76),
      ))
    }

@delegate:ResourceContentHash(110_913_118)
internal val Res.string.client_profile_validation_contact_description: StringResource by lazy {
      StringResource("string:client_profile_validation_contact_description", "client_profile_validation_contact_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4837, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9777, 97),
      ))
    }

@delegate:ResourceContentHash(-1_442_401_730)
internal val Res.string.client_profile_validation_contact_subject: StringResource by lazy {
      StringResource("string:client_profile_validation_contact_subject", "client_profile_validation_contact_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4919, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9875, 105),
      ))
    }

@delegate:ResourceContentHash(-1_860_249_542)
internal val Res.string.client_profile_validation_delete_email: StringResource by lazy {
      StringResource("string:client_profile_validation_delete_email", "client_profile_validation_delete_email", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4997, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9981, 94),
      ))
    }

@delegate:ResourceContentHash(-1_569_354_849)
internal val Res.string.client_profile_validation_delete_reason: StringResource by lazy {
      StringResource("string:client_profile_validation_delete_reason", "client_profile_validation_delete_reason", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5072, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10076, 111),
      ))
    }

@delegate:ResourceContentHash(-500_320_296)
internal val Res.string.client_profile_validation_first_name: StringResource by lazy {
      StringResource("string:client_profile_validation_first_name", "client_profile_validation_first_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5148, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10188, 76),
      ))
    }

@delegate:ResourceContentHash(973_901_533)
internal val Res.string.client_profile_validation_last_name: StringResource by lazy {
      StringResource("string:client_profile_validation_last_name", "client_profile_validation_last_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5217, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10265, 87),
      ))
    }

@delegate:ResourceContentHash(-1_502_685_945)
internal val Res.string.client_profile_validation_phone: StringResource by lazy {
      StringResource("string:client_profile_validation_phone", "client_profile_validation_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5281, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10353, 95),
      ))
    }

@delegate:ResourceContentHash(1_149_241_771)
internal val Res.string.client_review_add_photo: StringResource by lazy {
      StringResource("string:client_review_add_photo", "client_review_add_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5345, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10449, 47),
      ))
    }

@delegate:ResourceContentHash(575_666_506)
internal val Res.string.client_review_atmosphere: StringResource by lazy {
      StringResource("string:client_review_atmosphere", "client_review_atmosphere", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5381, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10497, 56),
      ))
    }

@delegate:ResourceContentHash(-1_312_822_820)
internal val Res.string.client_review_auth_required_message: StringResource by lazy {
      StringResource("string:client_review_auth_required_message", "client_review_auth_required_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5430, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10554, 207),
      ))
    }

@delegate:ResourceContentHash(676_065_620)
internal val Res.string.client_review_auth_required_title: StringResource by lazy {
      StringResource("string:client_review_auth_required_title", "client_review_auth_required_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5558, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10762, 77),
      ))
    }

@delegate:ResourceContentHash(1_437_126_835)
internal val Res.string.client_review_detail_rating: StringResource by lazy {
      StringResource("string:client_review_detail_rating", "client_review_detail_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5624, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10840, 75),
      ))
    }

@delegate:ResourceContentHash(686_113_272)
internal val Res.string.client_review_max_photos: StringResource by lazy {
      StringResource("string:client_review_max_photos", "client_review_max_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5680, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10916, 68),
      ))
    }

@delegate:ResourceContentHash(1_499_695_727)
internal val Res.string.client_review_overall_rating: StringResource by lazy {
      StringResource("string:client_review_overall_rating", "client_review_overall_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5737, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10985, 76),
      ))
    }

@delegate:ResourceContentHash(1_706_632_652)
internal val Res.string.client_review_personal: StringResource by lazy {
      StringResource("string:client_review_personal", "client_review_personal", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5794, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11062, 54),
      ))
    }

@delegate:ResourceContentHash(-279_441_904)
internal val Res.string.client_review_photo_picker_pending: StringResource by lazy {
      StringResource("string:client_review_photo_picker_pending", "client_review_photo_picker_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5833, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11117, 262),
      ))
    }

@delegate:ResourceContentHash(-808_526_385)
internal val Res.string.client_review_photo_title: StringResource by lazy {
      StringResource("string:client_review_photo_title", "client_review_photo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6024, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11380, 45),
      ))
    }

@delegate:ResourceContentHash(-725_032_592)
internal val Res.string.client_review_photo_upload_error: StringResource by lazy {
      StringResource("string:client_review_photo_upload_error", "client_review_photo_upload_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6066, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11426, 108),
      ))
    }

@delegate:ResourceContentHash(-739_215_897)
internal val Res.string.client_review_price: StringResource by lazy {
      StringResource("string:client_review_price", "client_review_price", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6139, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11535, 39),
      ))
    }

@delegate:ResourceContentHash(1_588_925_800)
internal val Res.string.client_review_quality: StringResource by lazy {
      StringResource("string:client_review_quality", "client_review_quality", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6175, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11575, 45),
      ))
    }

@delegate:ResourceContentHash(394_595_729)
internal val Res.string.client_review_speed: StringResource by lazy {
      StringResource("string:client_review_speed", "client_review_speed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6217, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11621, 51),
      ))
    }

@delegate:ResourceContentHash(131_103_401)
internal val Res.string.client_review_submit: StringResource by lazy {
      StringResource("string:client_review_submit", "client_review_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6478, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12022, 72),
      ))
    }

@delegate:ResourceContentHash(-316_447_924)
internal val Res.string.client_review_submit_error: StringResource by lazy {
      StringResource("string:client_review_submit_error", "client_review_submit_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6253, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11673, 102),
      ))
    }

@delegate:ResourceContentHash(1_064_868_213)
internal val Res.string.client_review_submit_success: StringResource by lazy {
      StringResource("string:client_review_submit_success", "client_review_submit_success", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6405, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11905, 116),
      ))
    }

@delegate:ResourceContentHash(756_586_122)
internal val Res.string.client_review_submit_success_message: StringResource by lazy {
      StringResource("string:client_review_submit_success_message", "client_review_submit_success_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6320, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11776, 128),
      ))
    }

@delegate:ResourceContentHash(1_389_003_331)
internal val Res.string.client_review_text_placeholder: StringResource by lazy {
      StringResource("string:client_review_text_placeholder", "client_review_text_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6527, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12095, 238),
      ))
    }

@delegate:ResourceContentHash(-2_026_065_508)
internal val Res.string.client_review_text_title: StringResource by lazy {
      StringResource("string:client_review_text_title", "client_review_text_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6662, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12334, 60),
      ))
    }

@delegate:ResourceContentHash(486_898_607)
internal val Res.string.client_review_title: StringResource by lazy {
      StringResource("string:client_review_title", "client_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6711, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12395, 47),
      ))
    }

@delegate:ResourceContentHash(-1_969_131_952)
internal val Res.string.client_review_value_hint: StringResource by lazy {
      StringResource("string:client_review_value_hint", "client_review_value_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6751, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12443, 124),
      ))
    }

@delegate:ResourceContentHash(441_098_617)
internal val Res.string.client_reviews_empty: StringResource by lazy {
      StringResource("string:client_reviews_empty", "client_reviews_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6840, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12568, 76),
      ))
    }

@delegate:ResourceContentHash(486_898_607)
internal val Res.string.client_reviews_latest: StringResource by lazy {
      StringResource("string:client_reviews_latest", "client_reviews_latest", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6947, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12723, 49),
      ))
    }

@delegate:ResourceContentHash(1_835_303_641)
internal val Res.string.client_reviews_latest_desktop: StringResource by lazy {
      StringResource("string:client_reviews_latest_desktop", "client_reviews_latest_desktop", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6889, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12645, 77),
      ))
    }

@delegate:ResourceContentHash(-1_543_049_706)
internal val Res.string.client_reviews_rating_details: StringResource by lazy {
      StringResource("string:client_reviews_rating_details", "client_reviews_rating_details", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6989, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12773, 53),
      ))
    }

@delegate:ResourceContentHash(667_965_285)
internal val Res.string.client_reviews_unknown_author: StringResource by lazy {
      StringResource("string:client_reviews_unknown_author", "client_reviews_unknown_author", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7039, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12827, 69),
      ))
    }

@delegate:ResourceContentHash(880_989_137)
internal val Res.string.client_saved_action_error: StringResource by lazy {
      StringResource("string:client_saved_action_error", "client_saved_action_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7089, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12897, 105),
      ))
    }

@delegate:ResourceContentHash(1_401_686_708)
internal val Res.string.client_saved_auth_required_message: StringResource by lazy {
      StringResource("string:client_saved_auth_required_message", "client_saved_auth_required_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7163, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13003, 174),
      ))
    }

@delegate:ResourceContentHash(676_065_620)
internal val Res.string.client_saved_auth_required_title: StringResource by lazy {
      StringResource("string:client_saved_auth_required_title", "client_saved_auth_required_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7266, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13178, 76),
      ))
    }

@delegate:ResourceContentHash(-1_110_655_460)
internal val Res.string.client_saved_empty_description: StringResource by lazy {
      StringResource("string:client_saved_empty_description", "client_saved_empty_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7331, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13255, 182),
      ))
    }

@delegate:ResourceContentHash(1_770_689_998)
internal val Res.string.client_saved_empty_title: StringResource by lazy {
      StringResource("string:client_saved_empty_title", "client_saved_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7426, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13438, 108),
      ))
    }

@delegate:ResourceContentHash(1_208_131_187)
internal val Res.string.client_saved_load_error: StringResource by lazy {
      StringResource("string:client_saved_load_error", "client_saved_load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7487, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13547, 135),
      ))
    }

@delegate:ResourceContentHash(1_512_203_131)
internal val Res.string.client_saved_remove_content_description: StringResource by lazy {
      StringResource("string:client_saved_remove_content_description", "client_saved_remove_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7555, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13683, 107),
      ))
    }

@delegate:ResourceContentHash(1_865_558_636)
internal val Res.string.client_saved_search_placeholder: StringResource by lazy {
      StringResource("string:client_saved_search_placeholder", "client_saved_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7627, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13791, 103),
      ))
    }

@delegate:ResourceContentHash(942_518_072)
internal val Res.string.client_saved_title: StringResource by lazy {
      StringResource("string:client_saved_title", "client_saved_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7695, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13895, 50),
      ))
    }

@delegate:ResourceContentHash(899_664_064)
internal val Res.string.client_tab_home: StringResource by lazy {
      StringResource("string:client_tab_home", "client_tab_home", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7730, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13946, 31),
      ))
    }

@delegate:ResourceContentHash(-224_406_506)
internal val Res.string.client_tab_map: StringResource by lazy {
      StringResource("string:client_tab_map", "client_tab_map", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7762, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13978, 38),
      ))
    }

@delegate:ResourceContentHash(-1_361_966_642)
internal val Res.string.client_tab_profile: StringResource by lazy {
      StringResource("string:client_tab_profile", "client_tab_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7789, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14017, 46),
      ))
    }

@delegate:ResourceContentHash(942_518_072)
internal val Res.string.client_tab_saved: StringResource by lazy {
      StringResource("string:client_tab_saved", "client_tab_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7828, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14064, 48),
      ))
    }

@delegate:ResourceContentHash(-821_441_203)
internal val Res.string.client_venue_action_catalog: StringResource by lazy {
      StringResource("string:client_venue_action_catalog", "client_venue_action_catalog", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7861, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14113, 55),
      ))
    }

@delegate:ResourceContentHash(1_958_861_502)
internal val Res.string.client_venue_action_phone: StringResource by lazy {
      StringResource("string:client_venue_action_phone", "client_venue_action_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7909, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14169, 53),
      ))
    }

@delegate:ResourceContentHash(-737_899_043)
internal val Res.string.client_venue_action_route: StringResource by lazy {
      StringResource("string:client_venue_action_route", "client_venue_action_route", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7951, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14223, 53),
      ))
    }

@delegate:ResourceContentHash(1_641_123_459)
internal val Res.string.client_venue_action_share: StringResource by lazy {
      StringResource("string:client_venue_action_share", "client_venue_action_share", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7993, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14277, 57),
      ))
    }

@delegate:ResourceContentHash(770_634_311)
internal val Res.string.client_venue_action_website: StringResource by lazy {
      StringResource("string:client_venue_action_website", "client_venue_action_website", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8035, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14335, 55),
      ))
    }

@delegate:ResourceContentHash(66_240_771)
internal val Res.string.client_venue_back_content_description: StringResource by lazy {
      StringResource("string:client_venue_back_content_description", "client_venue_back_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8083, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14391, 61),
      ))
    }

@delegate:ResourceContentHash(-2_009_834_008)
internal val Res.string.client_venue_closed: StringResource by lazy {
      StringResource("string:client_venue_closed", "client_venue_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8137, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14453, 51),
      ))
    }

@delegate:ResourceContentHash(-624_347_372)
internal val Res.string.client_venue_description: StringResource by lazy {
      StringResource("string:client_venue_description", "client_venue_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8173, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14505, 44),
      ))
    }

@delegate:ResourceContentHash(1_340_889_391)
internal val Res.string.client_venue_leave_review: StringResource by lazy {
      StringResource("string:client_venue_leave_review", "client_venue_leave_review", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8222, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14550, 73),
      ))
    }

@delegate:ResourceContentHash(575_666_506)
internal val Res.string.client_venue_rating_atmosphere: StringResource by lazy {
      StringResource("string:client_venue_rating_atmosphere", "client_venue_rating_atmosphere", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8272, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14624, 62),
      ))
    }

@delegate:ResourceContentHash(1_706_632_652)
internal val Res.string.client_venue_rating_personal: StringResource by lazy {
      StringResource("string:client_venue_rating_personal", "client_venue_rating_personal", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8327, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14687, 60),
      ))
    }

@delegate:ResourceContentHash(-739_215_897)
internal val Res.string.client_venue_rating_price: StringResource by lazy {
      StringResource("string:client_venue_rating_price", "client_venue_rating_price", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8372, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14748, 45),
      ))
    }

@delegate:ResourceContentHash(1_588_925_800)
internal val Res.string.client_venue_rating_quality: StringResource by lazy {
      StringResource("string:client_venue_rating_quality", "client_venue_rating_quality", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8414, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14794, 51),
      ))
    }

@delegate:ResourceContentHash(394_595_729)
internal val Res.string.client_venue_rating_speed: StringResource by lazy {
      StringResource("string:client_venue_rating_speed", "client_venue_rating_speed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8462, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14846, 57),
      ))
    }

@delegate:ResourceContentHash(486_898_607)
internal val Res.string.client_venue_reviews: StringResource by lazy {
      StringResource("string:client_venue_reviews", "client_venue_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8605, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15037, 48),
      ))
    }

@delegate:ResourceContentHash(-1_217_986_603)
internal val Res.string.client_venue_reviews_count: StringResource by lazy {
      StringResource("string:client_venue_reviews_count", "client_venue_reviews_count", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8504, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14904, 62),
      ))
    }

@delegate:ResourceContentHash(-987_507_858)
internal val Res.string.client_venue_reviews_view_all: StringResource by lazy {
      StringResource("string:client_venue_reviews_view_all", "client_venue_reviews_view_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8555, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14967, 69),
      ))
    }

@delegate:ResourceContentHash(-657_807_046)
internal val Res.string.client_venue_services_empty: StringResource by lazy {
      StringResource("string:client_venue_services_empty", "client_venue_services_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8646, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15086, 79),
      ))
    }

@delegate:ResourceContentHash(2_022_026_483)
internal val Res.string.client_venue_services_short_title: StringResource by lazy {
      StringResource("string:client_venue_services_short_title", "client_venue_services_short_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8702, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15166, 61),
      ))
    }

@delegate:ResourceContentHash(-999_760_356)
internal val Res.string.client_venue_services_title: StringResource by lazy {
      StringResource("string:client_venue_services_title", "client_venue_services_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8756, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15228, 71),
      ))
    }

@delegate:ResourceContentHash(2_019_557_306)
internal val Res.string.client_venue_status_closes_at: StringResource by lazy {
      StringResource("string:client_venue_status_closes_at", "client_venue_status_closes_at", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8812, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15300, 81),
      ))
    }

@delegate:ResourceContentHash(2_090_059_445)
internal val Res.string.client_venue_status_open: StringResource by lazy {
      StringResource("string:client_venue_status_open", "client_venue_status_open", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8927, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15463, 56),
      ))
    }

@delegate:ResourceContentHash(-763_685_287)
internal val Res.string.client_venue_status_opens_at: StringResource by lazy {
      StringResource("string:client_venue_status_opens_at", "client_venue_status_opens_at", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8870, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15382, 80),
      ))
    }

@delegate:ResourceContentHash(128_363_515)
internal val Res.string.client_web_install_button: StringResource by lazy {
      StringResource("string:client_web_install_button", "client_web_install_button", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8968, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15520, 65),
      ))
    }

@delegate:ResourceContentHash(452_490_742)
internal val Res.string.client_web_install_description: StringResource by lazy {
      StringResource("string:client_web_install_description", "client_web_install_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9014, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15586, 262),
      ))
    }

@delegate:ResourceContentHash(-276_523_697)
internal val Res.string.client_web_install_title: StringResource by lazy {
      StringResource("string:client_web_install_title", "client_web_install_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9169, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15849, 64),
      ))
    }

@delegate:ResourceContentHash(966_861_336)
internal val Res.string.client_web_profile_title: StringResource by lazy {
      StringResource("string:client_web_profile_title", "client_web_profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9218, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15914, 72),
      ))
    }

@delegate:ResourceContentHash(140_075_260)
internal val Res.string.onboarding_discover_description: StringResource by lazy {
      StringResource("string:onboarding_discover_description", "onboarding_discover_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15987, 203),
      ))
    }

@delegate:ResourceContentHash(510_524_606)
internal val Res.string.onboarding_discover_title: StringResource by lazy {
      StringResource("string:onboarding_discover_title", "onboarding_discover_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16191, 89),
      ))
    }

@delegate:ResourceContentHash(292_354_302)
internal val Res.string.onboarding_filters_map_description: StringResource by lazy {
      StringResource("string:onboarding_filters_map_description", "onboarding_filters_map_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16281, 194),
      ))
    }

@delegate:ResourceContentHash(-181_933_740)
internal val Res.string.onboarding_filters_map_title: StringResource by lazy {
      StringResource("string:onboarding_filters_map_title", "onboarding_filters_map_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16476, 76),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("client_profile_delete_account", Res.string.client_profile_delete_account)
  map.put("client_profile_delete_error", Res.string.client_profile_delete_error)
  map.put("client_profile_delete_reason_label", Res.string.client_profile_delete_reason_label)
  map.put("client_profile_delete_reason_placeholder", Res.string.client_profile_delete_reason_placeholder)
  map.put("client_profile_delete_success", Res.string.client_profile_delete_success)
  map.put("client_profile_delete_warning_message", Res.string.client_profile_delete_warning_message)
  map.put("client_profile_delete_warning_title", Res.string.client_profile_delete_warning_title)
  map.put("client_profile_edit", Res.string.client_profile_edit)
  map.put("client_profile_general_info", Res.string.client_profile_general_info)
  map.put("client_profile_load_error", Res.string.client_profile_load_error)
  map.put("client_profile_logout", Res.string.client_profile_logout)
  map.put("client_profile_my_reviews", Res.string.client_profile_my_reviews)
  map.put("client_profile_no_reviews", Res.string.client_profile_no_reviews)
  map.put("client_profile_reviews_load_error", Res.string.client_profile_reviews_load_error)
  map.put("client_profile_reviews_unknown_venue", Res.string.client_profile_reviews_unknown_venue)
  map.put("client_profile_save", Res.string.client_profile_save)
  map.put("client_profile_save_error", Res.string.client_profile_save_error)
  map.put("client_profile_save_success", Res.string.client_profile_save_success)
  map.put("client_profile_sign_in", Res.string.client_profile_sign_in)
  map.put("client_profile_success_title", Res.string.client_profile_success_title)
  map.put("client_profile_unknown_user", Res.string.client_profile_unknown_user)
  map.put("client_profile_user_activity", Res.string.client_profile_user_activity)
  map.put("client_profile_validation_contact_description", Res.string.client_profile_validation_contact_description)
  map.put("client_profile_validation_contact_subject", Res.string.client_profile_validation_contact_subject)
  map.put("client_profile_validation_delete_email", Res.string.client_profile_validation_delete_email)
  map.put("client_profile_validation_delete_reason", Res.string.client_profile_validation_delete_reason)
  map.put("client_profile_validation_first_name", Res.string.client_profile_validation_first_name)
  map.put("client_profile_validation_last_name", Res.string.client_profile_validation_last_name)
  map.put("client_profile_validation_phone", Res.string.client_profile_validation_phone)
  map.put("client_review_add_photo", Res.string.client_review_add_photo)
  map.put("client_review_atmosphere", Res.string.client_review_atmosphere)
  map.put("client_review_auth_required_message", Res.string.client_review_auth_required_message)
  map.put("client_review_auth_required_title", Res.string.client_review_auth_required_title)
  map.put("client_review_detail_rating", Res.string.client_review_detail_rating)
  map.put("client_review_max_photos", Res.string.client_review_max_photos)
  map.put("client_review_overall_rating", Res.string.client_review_overall_rating)
  map.put("client_review_personal", Res.string.client_review_personal)
  map.put("client_review_photo_picker_pending", Res.string.client_review_photo_picker_pending)
  map.put("client_review_photo_title", Res.string.client_review_photo_title)
  map.put("client_review_photo_upload_error", Res.string.client_review_photo_upload_error)
  map.put("client_review_price", Res.string.client_review_price)
  map.put("client_review_quality", Res.string.client_review_quality)
  map.put("client_review_speed", Res.string.client_review_speed)
  map.put("client_review_submit", Res.string.client_review_submit)
  map.put("client_review_submit_error", Res.string.client_review_submit_error)
  map.put("client_review_submit_success", Res.string.client_review_submit_success)
  map.put("client_review_submit_success_message", Res.string.client_review_submit_success_message)
  map.put("client_review_text_placeholder", Res.string.client_review_text_placeholder)
  map.put("client_review_text_title", Res.string.client_review_text_title)
  map.put("client_review_title", Res.string.client_review_title)
  map.put("client_review_value_hint", Res.string.client_review_value_hint)
  map.put("client_reviews_empty", Res.string.client_reviews_empty)
  map.put("client_reviews_latest", Res.string.client_reviews_latest)
  map.put("client_reviews_latest_desktop", Res.string.client_reviews_latest_desktop)
  map.put("client_reviews_rating_details", Res.string.client_reviews_rating_details)
  map.put("client_reviews_unknown_author", Res.string.client_reviews_unknown_author)
  map.put("client_saved_action_error", Res.string.client_saved_action_error)
  map.put("client_saved_auth_required_message", Res.string.client_saved_auth_required_message)
  map.put("client_saved_auth_required_title", Res.string.client_saved_auth_required_title)
  map.put("client_saved_empty_description", Res.string.client_saved_empty_description)
  map.put("client_saved_empty_title", Res.string.client_saved_empty_title)
  map.put("client_saved_load_error", Res.string.client_saved_load_error)
  map.put("client_saved_remove_content_description", Res.string.client_saved_remove_content_description)
  map.put("client_saved_search_placeholder", Res.string.client_saved_search_placeholder)
  map.put("client_saved_title", Res.string.client_saved_title)
  map.put("client_tab_home", Res.string.client_tab_home)
  map.put("client_tab_map", Res.string.client_tab_map)
  map.put("client_tab_profile", Res.string.client_tab_profile)
  map.put("client_tab_saved", Res.string.client_tab_saved)
  map.put("client_venue_action_catalog", Res.string.client_venue_action_catalog)
  map.put("client_venue_action_phone", Res.string.client_venue_action_phone)
  map.put("client_venue_action_route", Res.string.client_venue_action_route)
  map.put("client_venue_action_share", Res.string.client_venue_action_share)
  map.put("client_venue_action_website", Res.string.client_venue_action_website)
  map.put("client_venue_back_content_description", Res.string.client_venue_back_content_description)
  map.put("client_venue_closed", Res.string.client_venue_closed)
  map.put("client_venue_description", Res.string.client_venue_description)
  map.put("client_venue_leave_review", Res.string.client_venue_leave_review)
  map.put("client_venue_rating_atmosphere", Res.string.client_venue_rating_atmosphere)
  map.put("client_venue_rating_personal", Res.string.client_venue_rating_personal)
  map.put("client_venue_rating_price", Res.string.client_venue_rating_price)
  map.put("client_venue_rating_quality", Res.string.client_venue_rating_quality)
  map.put("client_venue_rating_speed", Res.string.client_venue_rating_speed)
  map.put("client_venue_reviews", Res.string.client_venue_reviews)
  map.put("client_venue_reviews_count", Res.string.client_venue_reviews_count)
  map.put("client_venue_reviews_view_all", Res.string.client_venue_reviews_view_all)
  map.put("client_venue_services_empty", Res.string.client_venue_services_empty)
  map.put("client_venue_services_short_title", Res.string.client_venue_services_short_title)
  map.put("client_venue_services_title", Res.string.client_venue_services_title)
  map.put("client_venue_status_closes_at", Res.string.client_venue_status_closes_at)
  map.put("client_venue_status_open", Res.string.client_venue_status_open)
  map.put("client_venue_status_opens_at", Res.string.client_venue_status_opens_at)
  map.put("client_web_install_button", Res.string.client_web_install_button)
  map.put("client_web_install_description", Res.string.client_web_install_description)
  map.put("client_web_install_title", Res.string.client_web_install_title)
  map.put("client_web_profile_title", Res.string.client_web_profile_title)
  map.put("onboarding_discover_description", Res.string.onboarding_discover_description)
  map.put("onboarding_discover_title", Res.string.onboarding_discover_title)
  map.put("onboarding_filters_map_description", Res.string.onboarding_filters_map_description)
  map.put("onboarding_filters_map_title", Res.string.onboarding_filters_map_title)
}
